import type { TourBasicInfoState } from '@/shared/api/types/tour-types'
import { useTranslation } from 'react-i18next'
import { TourGeneralFields } from '@/features/tour/tour-general-fields'
import { cn } from '@/shared/libs/cn'
import { FormSectionCard } from '@/shared/ui/form-section-card'
import { SectionSaveButton } from '@/shared/ui/section-save-button'

interface GeneralInfoCardProps {
  isEdit: boolean
  isFormReady: boolean
  basicInfo: TourBasicInfoState
  onChange: (value: TourBasicInfoState) => void
  isDirty: boolean
  isSaving: boolean
  isUpdating: boolean
  onSave: () => void
}

/** Duration, ticket link and featured flag. On edit it saves with the same call as the scope card. */
export function GeneralInfoCard({
  isEdit,
  isFormReady,
  basicInfo,
  onChange,
  isDirty,
  isSaving,
  isUpdating,
  onSave,
}: GeneralInfoCardProps) {
  const { t } = useTranslation()

  return (
    <FormSectionCard
      title={t('tour.generalInfo', { defaultValue: 'Thông tin chung' })}
      action={
        isEdit && (
          <SectionSaveButton disabled={isUpdating || !isDirty} saving={isSaving} onSave={onSave} />
        )
      }
    >
      <div className={cn(!isFormReady && 'pointer-events-none opacity-50')}>
        <TourGeneralFields value={basicInfo} onChange={onChange} />
      </div>
    </FormSectionCard>
  )
}
